import { Validator } from "./types/cosmos/base/tendermint/v1beta1/query"
import { VersionInfo } from "./types/cosmos/base/tendermint/v1beta1/query"
import { Module } from "./types/cosmos/base/tendermint/v1beta1/query"
import { ProofOp } from "./types/cosmos/base/tendermint/v1beta1/query"
import { ProofOps } from "./types/cosmos/base/tendermint/v1beta1/query"
import { Block } from "./types/cosmos/base/tendermint/v1beta1/types"
import { Header } from "./types/cosmos/base/tendermint/v1beta1/types"


export {     
    Validator,
    VersionInfo,
    Module,
    ProofOp,
    ProofOps,
    Block,
    Header,
    
 }